module.exports = __webpack_public_path__ + "static/media/subImg3.2db8d2c6.png";